export const formatPid = (pid) => pid ? String(pid).toUpperCase() : "—";
export const formatTicketPid = (ticketPid) => ticketPid ? String(ticketPid).toUpperCase() : "—";
